import React from 'react';
import { Box, Container } from '@mui/material';
import Navigation from './Navigation';
import SimpleFooter from './SimpleFooter';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        position: 'relative',
      }}
    >
      <Navigation />
      <Box
        component="main"
        sx={{
          flex: '1 0 auto',
          pt: { xs: '180px', sm: '200px', md: '220px' },
          pb: { xs: 8, sm: 10, md: 12 },
        }}
      >
        <Container maxWidth="lg">
          {children}
        </Container>
      </Box>
      <Box
        sx={{
          flexShrink: 0,
          width: '100%',
        }}
      >
        <SimpleFooter />
      </Box>
    </Box>
  );
};

export default Layout; 